import { createLogger } from '../../../../app/logger'
import { useStyles } from './CheckinModal.styles'
import useAppDispatch from '../../../../hooks/useAppDispatch'
import useAppSelector from '../../../../hooks/useAppSelector'
import {
  PanelState,
  getCheckedInSelector,
  getPanelStateSelector,
  setPanelState,
  setSelectedEntry,
  setDirtyInput,
} from '../../checkinSlice'
import { Box, Button } from '@mui/material'
import clsx from 'clsx'
import { CheckInButton } from './CheckInButton'

// eslint-disable-next-line no-unused-vars
const logger = createLogger({
  prefix: 'ActionButtonsContent',
})

type ActionButtonsProps = {
  onCloseCancel: () => void
}

export const ActionButtons = (props: ActionButtonsProps) => {
  const { onCloseCancel } = props
  const { classes } = useStyles()
  const dispatch = useAppDispatch()

  const checkedIn = useAppSelector(getCheckedInSelector)

  const onClose = () => {
    dispatch(setSelectedEntry(undefined))
    dispatch(setPanelState(PanelState.HIDDEN))
    dispatch(setDirtyInput(false))
  }

  const panelState = useAppSelector(getPanelStateSelector)

  switch (panelState) {
    case PanelState.EDIT:
      if (checkedIn) {
        return (
          <Box
            className={classes.actions}
            display={'flex'}
            justifyContent={'space-between'}
            width={'100%'}
          >
            <Button
              data-cy={'modal-cancel-btn'}
              onClick={onClose}
              className={clsx(classes.button, classes.cancelButton)}
              variant={'text'}
            >
              Cancel
            </Button>
            <CheckInButton buttonText='UnCheck-In' isCheckingIn={false} />
          </Box>
        )
      } else {
        return (
          <Box
            className={classes.actions}
            display={'flex'}
            justifyContent={'space-between'}
            width={'100%'}
          >
            <Button
              data-cy={'modal-cancel-btn'}
              onClick={onCloseCancel}
              className={clsx(classes.button, classes.cancelButton)}
              variant={'text'}
            >
              Cancel
            </Button>
            <CheckInButton buttonText='Check-In' isCheckingIn={true} />
          </Box>
        )
      }
    case PanelState.PROCESSING:
    case PanelState.HIDDEN:
    case PanelState.ERROR:
    default:
      return null
  }
}
